import { Component, OnInit, ViewChildren, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service';
import { SopDetail, SopStep, Comments, SelectedStep } from '../Models';
import { PHBHPLayoutPackageService , PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AttachSession } from 'protractor/built/driverProviders';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-start-sopobserve',
  templateUrl: './ph-bhp-start-sopobserve.component.html',
  styleUrls: ['./ph-bhp-start-sopobserve.component.css']
})
export class PhBhpStartSopobserveComponent implements OnInit {
  isCollapsed = true;
  resizeFlage = true;
  done = false;
  hovered = false;

  @Input() sopDetail: SopDetail;
  @Input() userData: any;
  @Input() formdata: any;
  @Input() isDesktop: boolean;
  @Output() action = new EventEmitter();

  @ViewChildren('card') cards;
  @ViewChild('cardHolder') cardHolder;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('deselectStepModal') deselectStepModal;
  @ViewChild('deselectfromCenterModel') deselectfromCenterModel;

  sopStep: Array<SopStep>;
  sopStepLength: number;
  seletedSteps: Array<Array<SelectedStep>> = [];
  showStepList: Object = {};
  stepCount = 0;
  newModalRef: BsModalRef
  comments: Array<Comments> = [];
  deselectIndex: Array<number> = [];
  stepNumber: number;
  stepIndex: Array<Array<number>> = [];
  clickNoSterility: Boolean = false;
  clickComment: Boolean = false;
  numberToName: Array<string> = [];
  stepObservations = [];
  showProfessionalSubcategory: boolean
  InstitutionsList: any;
  subscription: Subscription;
  subscriptionInstitution: Subscription;
  selectedInstitution
  enableNosterility : boolean = true;
  subStepCounter: number = 0;
  selectedStepType: boolean = false;
  oneClick = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  hasRelevantSteps: boolean = false;
  countRelevantSteps: number = 0;
  relevantStepsSelected: number = 0;
  relevantStepCompliant: Boolean = false;
  initialCommentsLength: number = 0;
  swappedSteps: boolean = false;

  constructor(
    private modalService: BsModalService,
    public service: PhBhpFeaturePackageSopobservationService,
    public layoutService: PHBHPLayoutPackageService,
    public modalRef: BsModalRef,
    public appConfig: AppConfig,
    private listservice: PHBHPListApiService) { }

  ngOnInit() {
    if (this.sopDetail && this.sopDetail.sopid) {
      this.sopStep = JSON.parse(this.sopDetail.sopStepsVersions[0].stepsJsonFile) as Array<SopStep>;
      this.sopStep.forEach((value, index) => {
          value.stepCards.forEach(sc =>{
            if(!value.stepType && sc.hygieneRelevantStep)
            {
              this.hasRelevantSteps = true;
              this.relevantStepCompliant = false;
              this.countRelevantSteps++;
            }
          });
      });

      if(!this.hasRelevantSteps)
        this.relevantStepCompliant=true;

      this.sopStepLength = this.sopStep.length - 1;
      this.seletedSteps = [];
      this.showStepList = {};
      this.stepCount = 0;
      this.done = false;
    }
    this.callTimeOutLine();


    if (this.appConfig.institutions) {
      this.getInstitutionsbyId()
    } else {
      this.subscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
        this.getInstitutionsbyId()
      })
    }
  }

  getInstitutionsbyId() {
    var roleId = this.appConfig.userData.roleName.roleId;
    this.listservice.getInstitutionsbyId(this.appConfig.institutions, roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      if(this.layoutService.institutionID)
      {
        this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === this.layoutService.institutionID).institution.isNoSterility;
        this.enableNosterility = this.selectedInstitution;
        this.service.getConfigDetails(this.layoutService.institutionID).subscribe((res) => {
          this.showProfessionalSubcategory = res.enableProfessionalSubCategory;
          });
      }


    });
  }


  closeWindow(confirmationSOP: TemplateRef<any>) {
    this.newModalRef = this.modalService.show(confirmationSOP, Object.assign({}, { class: 'w-420 yes-no-modal' }));
    //this.modalRef.hide();
  }

  selectStep(index, Jindex , stepType) {
    if (this.done) {
      return;
    }
    if (!this.seletedSteps[index]) {
      this.seletedSteps[index] = [];
    }
    this.selectedStepType = stepType;
    if (!this.seletedSteps[index][Jindex]) {
      this.seletedSteps[index][Jindex] = {
        stepOrder: ++this.stepCount,
        stepID: this.sopStep[index].stepId,
        stepCardId: this.sopStep[index].stepCards[Jindex].stepCardId,
        hygieneRelevantStep: this.sopStep[index].stepCards[Jindex].hygieneRelevantStep,
        noSterility: false
      } as SelectedStep

      if(this.sopStep[index].stepCards[Jindex].hygieneRelevantStep)
        this.relevantStepsSelected++;

      this.stepIndex.push([index, Jindex]);
      // if (this.sopStep[index].stepCards[Jindex].hygieneRelevantStep === 'Hygiene') {
      //   this.seletedSteps[index][Jindex].hygieneRelevantStep = true;
      // }
      this.numberToName.push(this.sopStep[index].stepCards[Jindex].stepTittle);
      if(stepType){
        this.subStepCounter++;
      }
      this.clickNoSterility = false;
      this.clickComment = false;
    } else if (this.seletedSteps[index][Jindex].stepOrder === this.stepCount) {
      this.deselectIndex[0] = index;
      this.deselectIndex[1] = Jindex;
      this.clickNoSterility = this.seletedSteps[index][Jindex].noSterility;
      this.newModalRef = this.modalService.show(this.deselectStepModal, Object.assign({}, { class: 'w-420 yes-no-modal' }));
    } else {
      this.deselectIndex[0] = index;
      this.deselectIndex[1] = Jindex;
      this.clickNoSterility = this.seletedSteps[index][Jindex].noSterility;
      this.newModalRef = this.modalService.show(this.deselectfromCenterModel, Object.assign({}, { class: 'w-420 yes-no-modal' }));
    }

    this.updateSwappedFlags();
  }

  deselectStep() {
    if(this.selectedStepType){
      this.subStepCounter--;
    }
    if(this.seletedSteps[this.deselectIndex[0]][this.deselectIndex[1]].hygieneRelevantStep){
        this.relevantStepsSelected--;
      }

    delete this.seletedSteps[this.deselectIndex[0]][this.deselectIndex[1]];
    this.deselectIndex = [];
    this.numberToName.pop();
    this.stepIndex.pop()
    --this.stepCount;
    this.clickNoSterility = false;
    this.clickComment = false;

    this.updateSwappedFlags();
  }

  deselectfromCenter() {
    if(this.selectedStepType){
      this.subStepCounter--;
    }
    var removeCount = this.seletedSteps[this.deselectIndex[0]][this.deselectIndex[1]].stepOrder;
    if(this.seletedSteps[this.deselectIndex[0]][this.deselectIndex[1]].hygieneRelevantStep){
      this.relevantStepsSelected--;
    }
    delete this.seletedSteps[this.deselectIndex[0]][this.deselectIndex[1]];
    this.stepIndex.splice(removeCount - 1, 1);
    this.numberToName.splice(removeCount - 1, 1);
    this.stepIndex.forEach(res => {
      if (this.seletedSteps[res[0]][res[1]].stepOrder > removeCount) {
        this.seletedSteps[res[0]][res[1]].stepOrder--;
      }
    })
    --this.stepCount;
    this.clickNoSterility = false;
    this.clickComment = false;

    this.updateSwappedFlags();
  }

  noSterility() {
    if(this.stepIndex.length == 0) return;

    this.clickNoSterility = !this.clickNoSterility;

    let indexList = this.stepIndex[this.stepIndex.length - 1];
    let lastStep = this.seletedSteps[indexList[0]][indexList[1]];

    lastStep.noSterility = !lastStep.noSterility;
  }

  showStep(index, step) {
    if (this.done) {
      return;
    }
    if (!this.seletedSteps[index]) {
      this.seletedSteps[index] = [];
    }
    if (!this.showStepList[index]) {
      this.showStepList[index] = true;
    }
    if(step.stepType && !step.opened){
      step.opened = true;
      step.stepCards.forEach(sc=>{
        if(sc.hygieneRelevantStep)
        {
          this.hasRelevantSteps = true;
          this.relevantStepCompliant = false;
          this.countRelevantSteps++;
        }
      })
    }
    this.callTimeOutLine();
  }

  removeCardLine() {
    let childNodes = this.cardHolder.nativeElement.childNodes;
    childNodes.forEach((child) => {
      if (child.classList && child.classList.contains('horz-Line')) {
        child.remove();
      }
    });
  }

  cardNextLine() {
    const winWidth = window.innerWidth;
    let addChildNodeAtLast = false;
    this.cards.forEach((card, index) => {
      const phElement = card.nativeElement;
      if (this.cards._results[index + 1]) {
        this.cards._results[index + 1].nativeElement.classList.remove('nextRowFirstCard');
      }
      phElement.classList.remove('rowLastCard')

      const childNodes = phElement.childNodes[0];
      if (childNodes.classList && childNodes.classList.contains('rowLastCard1')) {
        childNodes.remove();
      }
      if (childNodes.classList && childNodes.classList.contains('nextRowFirstCard1')) {
        childNodes.remove();
      }
      var mutliStep = false;
      // mutli-step-start-image
      if (this.cards._results[index + 1] && phElement.classList.contains('mutli-step-start-image')) {
        const childNodesOfMultiStack = phElement.childNodes;

        // use for each instead

        childNodesOfMultiStack.forEach(element => {
          if (element.classList && element.classList.contains('start-image-end')) {
            addChildNodeAtLast = true;
            element.remove();
          }
        });
      }
      if(phElement.classList.contains('mutli-step-sub-cards')){
        mutliStep = true;
      }
      const cardWidth = phElement.offsetWidth;
      const cardHeight = phElement.offsetHeight;
      const cardLeft = phElement.offsetLeft;
      const cardTop = phElement.offsetTop;

      const difHeight = cardTop + cardHeight;
      if(mutliStep){
        var tempCardWidth = cardWidth;
      } else {
        var tempCardWidth = cardWidth +14 ;
      }

      if(mutliStep){

        var difWidth = winWidth - (cardWidth - 14 + cardLeft);
      } else {
        var difWidth = winWidth - (cardWidth + cardLeft);
      }
      if (difWidth < (tempCardWidth + 26)) {

        phElement.classList.add('rowLastCard');
        phElement.insertAdjacentHTML('afterbegin', `<div class='rowLastCard1'></div>`);
        if (this.cards._results[index + 1]) {
          const phElement1 = this.cards._results[index + 1].nativeElement;
          phElement1.classList.add('nextRowFirstCard');
          phElement1.insertAdjacentHTML('afterbegin', `<div class='nextRowFirstCard1'></div>`);
          this.cardHolder.nativeElement.insertAdjacentHTML('afterbegin', '<div class="horz-Line" style="top:'
            + (difHeight + 14) + 'px;width:' + (cardLeft - 54) + 'px"></div>');
        }
      }

      if (addChildNodeAtLast && (this.cards.length === index + 1)) {
        addChildNodeAtLast = false;
        let endImage = document.createElement('div');
        endImage.className = 'start-image-end d-flex align-items-center';

        phElement.appendChild(endImage);
      }
    });
  }

  onResize(event) {
    if (this.resizeFlage) {
      this.resizeFlage = false;
      this.removeCardLine();
      this.cardNextLine();
      this.resizeFlage = true;
    }
  }

  expanded() {
    this.callTimeOutLine();
  }

  callTimeOutLine() {
    setTimeout(() => {
      this.removeCardLine();
      this.cardNextLine();
    }, 1);
  }

  submitData() {
    if (this.seletedSteps.length === 0) {
      return false;
    }
    if (!this.done) {
      this.done = true;
      this.seletedSteps.forEach(val => {
        val.forEach(stepObservations => {
          stepObservations.sopid = this.sopDetail.sopid;
          this.stepObservations.push(stepObservations);
        });
      });
      this.action.emit({ key: 'beforePostingSOP' });
      return;
    }
    if(this.oneClick){
      return false;
    }
    this.oneClick = true;

    if(this.hasRelevantSteps)
    {
      if(this.countRelevantSteps == this.relevantStepsSelected)
        this.relevantStepCompliant = true;
    }

    const data = {
      sopid: this.sopDetail.sopid,
      institutionID: this.layoutService.institutionID,
      sopStepsVersionID: this.sopDetail.sopStepsVersions[0].stepsVersionID,
      observedJson: JSON.stringify(this.seletedSteps),
      departmentID: this.formdata.department.departmentID,
      wardID: this.formdata.ward.wardID,
      departmentTypeID: this.formdata.ward.departmentTypeID,
      professsionalCategoryID: this.formdata.category.categoryID,
      professionalSubCategoryID: this.formdata.subCategory.subCategoryID,
      noSterility: this.stepObservations.some(x => x.noSterility),
      observationComments: JSON.stringify(this.comments),
      createdBy: this.userData.userId,
      stepObservations: this.stepObservations,
      sopObservationComments: this.comments,
      IsSubStep : this.subStepCounter > 0 ? true : false ,
      isRelevantStepCompliant : this.relevantStepCompliant
    };

    this.service.createObservation(data).subscribe((res) => {
      this.sopStepLength = this.sopStep.length - 1;
      this.seletedSteps = [];
      this.showStepList = {};
      this.stepCount = 0;
      this.done = false;
      this.subStepCounter = 0;
      this.modalRef.hide();
      this.hasRelevantSteps = false;
      this.countRelevantSteps = 0;
      this.relevantStepsSelected = 0;
      this.action.emit({ key: 'saveSuccess' });
    });
  }

  onchildData(value) {
    switch (value.key) {
      case 'close':
        this.isCollapsed = !this.isCollapsed;
        this.CheckClickComment();
        break;
    }
  }

  openComment() {
    if (!this.isCollapsed) {
      this.CheckClickComment();
    } else {
      this.initialCommentsLength = this.comments.length;
    }
    if (this.isDesktop) {
      this.isCollapsed = !this.isCollapsed;
    } else {
      this.action.emit({
        key: 'openComment',
        data: {
          institutions :this.appConfig.institutions,
          userData: this.appConfig.userData,
          comments: this.comments,
          isCollapsed: this.isCollapsed,
          numberToName: this.numberToName,
          sopid: this.sopDetail.sopid
        }
      });
    }
  }

  errImg(e:Event){
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  private CheckClickComment() {
    if (this.comments.length > this.initialCommentsLength) {
      this.clickComment = true;
    } else {
      this.clickComment = false;
    }
  }

  private updateSwappedFlags(): void {
    const visitedStepOrders: Set<number> = new Set();
    this.swappedSteps = false;

    for (const stepGroup of this.seletedSteps) {
      if (stepGroup) {
        for (let i = 0; i < stepGroup.length; i++) {
          const stepCard = stepGroup[i];
          if (stepCard) {
            if (!this.previousStepsExist(visitedStepOrders, stepCard.stepOrder)) {
              stepCard.swapped = true;
              this.swappedSteps = true;
            } else {
              stepCard.swapped = false;
            }
            visitedStepOrders.add(stepCard.stepOrder);
          }
        }
      }
    }
  }

  private previousStepsExist(set: Set<number>, x: number): boolean {
    for (let i = 1; i < x; i++) {
      if (!set.has(i)) {
        return false;
      }
    }
    return true;
  }

}
